// removed by extract-text-webpack-plugin
module.exports = {"DesktopNavigation":"src-components-Header----DesktopNavigation-module---DesktopNavigation---35Lkp","socialMediaIcons":"src-components-Header----DesktopNavigation-module---socialMediaIcons---2k3WE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/DesktopNavigation.module.css
// module id = 379
// module chunks = 114276838955818